<template>
  <div class="mainq">
    <div class="headq">{{ lang.sc }}</div>
    <div class="tags">
      <div :class="['tag',types == 1 ? 'active':'']" @click="selectTag(1)">{{ lang.jmhb }}</div>
      <div :class="['tag',types == 2 ? 'active':'']" @click="selectTag(2)">{{ lang.qh }}</div>
    </div>

    <div class="membernewsq">
        <div id="newsBox">
          <ul class="newsList">
            <li v-for="(item,index) in coinList" :key="index" @click="goGoods(item)">
              <div class="token-logo" >
                <img :src="apiSer+item.img" v-if="types == 1">
                {{item.name}}
                <span v-if="types == 1">/{{ item.currency }}</span>
              </div>
              <div :class="[item.incPct > 0 ? 'red' : 'green']">
                <SimpleLineChart :message="item.history" :color="item.incPct < 0 ? '#ce7735' : '#c2e22a'"/>
              </div>
              <div  class='price'>
                <span >{{ item.price }}</span>
                <span :class="[item.incPct > 0 ? 'green' : 'red']">{{ item.incPct }}%</span>
              </div>
              <p class="tag" v-if="types == 2">{{ item.currency }}</p>

            </li>
          </ul>
        </div>
    </div>
    <Bottom />
  </div>
</template>
<script>
  import {
    mapState
  } from 'vuex';
  import axios from 'axios'
  import {API_SERVER} from '@/assets/js/config' 
  export default {
    data() {
      return {
        list: [],
        USDT:[],
        coinList:[],
        timer:null,
        apiSer:API_SERVER,
        fetching: false,
        types: 1,

        socket: null,
        messages: [],
      }
    },
    beforeDestroy(){
      clearInterval(this.timer);
      this.timer = null;
      this.socket.close();
      this.socket = null;
    },
    created() {
      clearInterval(this.timer)
      this.timer = setInterval(()=>{
        this.getData()
      },2e3)
    },
    computed: {
      ...mapState(['lang'])
    },
    methods: {
      // getData(){
      //   var url = this.apiSer.replace('http','ws')
      //   this.socket = new WebSocket(url + '/ws');
      //   this.socket.onmessage = (event) => {
      //     // Parse JSON message
      //     const message = JSON.parse(event.data);
      //     this.coinList = message.data.data
      //   };
      // },
      selectTag(index){
        this.types = index
        this.coinList = []
        this.getData()
      },
      getData(){
        this.$xhrGet('/ws',{'types':this.types}).then(res => {
          if (res.err == 0) {
            this.coinList = res.data
          }
        })
      },
      goGoods(item){
        if (this.types == 1){
          window.location.href = '/#/Goods?coinName=' + item.title
        }else {
          window.location.href = '/#/Futures?cid=' + item.id
        }

      },
    }
  }
</script>
<style  >
.mainq{
  background: #000;
  color: #fff;
  height: 100%;
}
.headq{
  padding: 10px;
  height: 5%;
  font-size: 20px;
  font-weight: 600;
}
.tags{
  display: flex;
  padding: 4px 20px;
}
.tags .tag{
  padding: 7px 15px;
  font-size:12.5px;
  color:hsla(0,0%,100%,.3) ;
}
.tags .active{
  color: #fff;
  background: #1a1a1a;
  border-radius:20px;
}
.membernewsq {
  height: 87%;
  margin: 10px;
  overflow: auto;
}
.membernewsq .title {
  color: #333;
  font-size: 16px;
  font-weight: bold;
  line-height: 30px;
  margin: 10px 0;
}

.membernewsq #newsBox {
  background: #1a1a1a;
  border-radius: 5px;
}
.membernewsq #newsBox .newsList {
  padding: 10px ;
}
.membernewsq #newsBox .newsList li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #fff;
  margin-bottom: 10px;
  position: relative;
}
.membernewsq #newsBox .newsList li .tag{
  position: absolute;
  left: 0;
  bottom: 0;
  font-size: 12px;
  opacity: 0.4;
}
.membernewsq #newsBox .newsList li .token-logo{
  flex: 0 0 40%;
  text-align: left;
  margin-bottom: 5px;
}
.membernewsq #newsBox .newsList li .price{
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.membernewsq #newsBox .newsList li:first-child {
  color: #fff;
}
.membernewsq #newsBox .newsList li:last-child {
  border: none;
}
.membernewsq #newsBox .newsList li div {
  flex: 0 0 25%;
  text-align: center;
}
.membernewsq #newsBox .newsList li div .red {
  color: #ce7735;
}
.membernewsq #newsBox .newsList li div .green {
  color: #c2e22a;
}
.membernewsq #newsBox .newsList li .token-logo{
  font-size: 13px;
  display: flex;
  align-items: center;
}
.membernewsq #newsBox .newsList li .token-logo img{
  width: 30px;
  margin-right: 10px;

}

</style>